<template>
  <div class="ma-4 app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-form>
      <v-row dense>
        <v-col>
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col>
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col>
          <v-select multiple dense v-model="body.status" :items="status" label="Status" outlined>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ body.status.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleStatus">
                <v-list-item-action>
                  <v-icon :color="body.status.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconStatus }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-text-field
            dense
            :value="numeroOrigem"
            @change="v => (numeroOrigem = v)"
            label="Número de Origem"
            outlined
            hint="Ex.: 7000,7001,7002-7005"
            persistent-hint
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            :value="numeroDestino"
            @change="v => (numeroDestino = v)"
            label="Número de Destino"
            outlined
            hint="Ex.: 7000,7001,7002-7005"
            persistent-hint
          />
        </v-col>
        <v-col>
          <v-select
            multiple
            dense
            outlined
            v-model="body.centroDeCusto"
            :items="centroDeCusto"
            label="Centro de Custo"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ body.centroDeCusto.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleDiaSemana">
                <v-list-item-action>
                  <v-icon :color="body.centroDeCusto.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconCentroDeCusto }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col>
          <v-text-field
            dense
            :value="protocol"
            @change="v => (protocol = v)"
            label="Protocolo"
            outlined
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" color="orangePcm" dark @click="exportExcel"
          >Exportar</v-btn
        >
        <v-btn class="mr-1" color="bluePcm" @click="emitEvent()" dark
          >Gerar</v-btn
        >
      </v-row>
    </v-form>
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div>
      <div class="ma-2" v-show="lista && !showSkeleton">
        <v-divider />
        <ListaRelatorioChamadas :chamadas-recebidas="chamadasRecebidas" :form="body" />
      </div>
      <v-row dense v-if="body.lastPage" class="mx-2 my-n4" align="center" justify="center">
        <span class="ml-8 grey--text">
          Itens: {{ body.initialItem }} - {{ body.finalItem }} de {{ body.totalItens }}
        </span>
        <v-spacer />
        <div class="mr-2">
          <ListPagination
            :page="body.currentPage"
            :numberOfPages="body.lastPage"
            @firstPage="firstPage"
            @formerPage="formerPage"
            @nextPage="nextPage"
            @lastPage="lastPage"
          />
        </div>
      </v-row>
    </div>
    <div v-for="n in 2" :key="`spacer_${n}`">
      <v-divider vertical />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Snackbar from '@/componentes/Snackbar'
import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import relatorioChamadasStore from '../_store'
import { relatorioChamadasMethods } from '../_utils/relatorioChamadasMethods'

import ListaRelatorioChamadas from './ListaRelatorioChamadas'

export default {
  components: { ListaRelatorioChamadas, Snackbar, ListPagination },
  mixins: [initialAndFinalDateTextInputReportForm],
  data: () => ({
    body: {
      dataHoraInicio: '',
      dataHoraFim: '',
      numeroOrigem: [],
      numeroDestino: [],
      centroDeCusto: [],
      status: [],
      protocol:[],
      currentPage: 1,
      lastPage: null,
      initialItem: null,
      finalItem: null,
      totalItens: null,
    },
    snackbar: false,
    text: '',
    centroDeCusto: [],
    centroDeCustoSelecionado: [],
    numeroOrigem: '',
    numeroDestino: '',
    protocol:'',
    status: [
      { text: 'Atendida', value: 'atendida' },
      { text: 'Ocupado', value: 'ocupado' },
      { text: 'Acesso Negado', value: 'acessoNegado' },
      { text: 'Não Atendida', value: 'naoAtendida' },
      { text: 'Erro', value: 'error' },
      { text: 'Outros', value: 'outros' },
      { text: 'Pendente', value: 'pending' },
    ],
    lista: false,
    chamadasRecebidas: [],
    showSkeleton: false,
  }),

  computed: {
    ...mapGetters('relatorioChamadasModulePABXStore', ['getCentroDeCustos', 'getRelatorioChamadas']),
    todosCentrosDeCustoSelecionados() {
      return this.body.centroDeCusto.length === this.centroDeCusto.length
    },
    algunsCentrosDeCustoSelecionados() {
      return this.body.centroDeCusto.length > 0 && !this.todosCentrosDeCustoSelecionados
    },
    iconCentroDeCusto() {
      if (this.todosCentrosDeCustoSelecionados) return 'mdi-close-box'
      if (this.algunsCentrosDeCustoSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    todosStatusSelecionados() {
      return this.body.status.length === this.status.length
    },
    algunsStatusSelecionados() {
      return this.body.status.length > 0 && !this.todosStatusSelecionados
    },
    iconStatus() {
      if (this.todosStatusSelecionados) return 'mdi-close-box'
      if (this.algunsStatusSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    this.body.currentPage = 1
    registerVuexModule(this.$store, 'relatorioChamadasModulePABXStore', relatorioChamadasStore)

    await Promise.all([this.listarCentroDeCustos(), this.listarConferencias()])

    this.centroDeCusto = this.getCentroDeCustos.map(centroDeCustos => ({
      text: `${centroDeCustos.codigo} - ${centroDeCustos.description}`,
      value: centroDeCustos.codigo,
    }))
  },

  methods: {
    ...mapActions('relatorioChamadasModulePABXStore', [
      'listarCentroDeCustos',
      'listarRelatorioChamadas',
      'listarConferencias',
    ]),
    ...relatorioChamadasMethods,
    toggleDiaSemana() {
      this.$nextTick(() => {
        if (this.todosCentrosDeCustoSelecionados) {
          this.body.centroDeCusto.splice(0)
        } else {
          this.body.centroDeCusto.splice(0)
          this.body.centroDeCusto = this.centroDeCusto.map(operador => operador.value)
        }
      })
    },
    toggleStatus() {
      this.$nextTick(() => {
        if (this.todosStatusSelecionados) {
          this.body.status.splice(0)
        } else {
          this.body.status.splice(0)
          this.body.status = this.status.map(status => status.value)
        }
      })
    },
  },

  watch: {
    numeroOrigem(novo) {
      this.body.numeroOrigem = this.numeroOrigemDestinoFormer(novo)
      if (this.body.numeroOrigem[0] === '' && this.body.numeroOrigem.length === 1) this.body.numeroOrigem.splice(0, 1)
    },
    numeroDestino(novo) {
      this.body.numeroDestino = this.numeroOrigemDestinoFormer(novo)
      if (this.body.numeroDestino[0] === '' && this.body.numeroDestino.length === 1)
        this.body.numeroDestino.splice(0, 1)
    },
    protocol(novo) {
      this.body.protocol = this.protocolNovo(novo)
      if (this.body.protocol[0] === '' && this.body.protocol.length === 1)
        this.body.protocol.splice(0, 1)
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
